import { Rate } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceRate",
  extends: Rate,
  mixins: [Rate, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    rateDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
